/**
 * PostHog env — supports legacy KEY and current PROJECT_TOKEN naming.
 * Host must be the ingestion API (US: https://us.i.posthog.com, EU: https://eu.i.posthog.com).
 */
export function getPostHogProjectToken(): string | undefined {
  const token =
    process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim() ||
    process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN?.trim();
  return token || undefined;
}

export function getPostHogApiHost(): string | undefined {
  return process.env.NEXT_PUBLIC_POSTHOG_HOST?.trim() || undefined;
}

export function isPostHogConfigured(): boolean {
  return Boolean(getPostHogProjectToken() && getPostHogApiHost());
}

/** Dashboard UI host derived from ingestion host (for reverse-proxy setups). */
export function getPostHogUiHost(apiHost: string): string {
  if (apiHost.includes("eu.i.posthog.com")) {
    return "https://eu.posthog.com";
  }
  return "https://us.posthog.com";
}
